import instance from "../Api/Instance";
import { back } from "../Api/ApiUrl";
import { useState } from "react";

export default function useReport() {
  const [reportData, setReportData] = useState({
    status: "loading",
    data: [],
    statusCode: 0,
    message: "Cargando...",
  });

  const fetchReportData = async (shipmentCode, reportType, fullTelemetry) => {
    setReportData({
      status: "loading",
      data: [],
      statusCode: 0,
      message: "Cargando...",
    });

    try {
      const response = await instance.get(back.getReportData, {
        params: { shipmentCode, reportType, fullTelemetry },
      });

      const fetchResponse = {
        data: response.data,
        status: "loaded",
        statusCode: response.status,
        message: "",
      };

      setReportData(fetchResponse);
      return fetchResponse;
    } catch (error) {
      const errorResponse = {
        data: [],
        status: "error",
        statusCode: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      };

      setReportData(errorResponse);
      return errorResponse;
    }
  };

  return { reportData, fetchReportData };
}
